// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"26efe0f5","977":"0a499878"}[chunkId] + ".chunk.js";
};